module.exports = {"TXTCLI_Free_Spins":{"id":"TXTCLI_Free_Spins","defaultMessage":"Tours gratuits","track":"Free Spins"}}